import { render, staticRenderFns } from "./video-preview.vue?vue&type=template&id=e1567cd8&scoped=true&"
import script from "./video-preview.vue?vue&type=script&lang=js&"
export * from "./video-preview.vue?vue&type=script&lang=js&"
import style0 from "./video-preview.vue?vue&type=style&index=0&id=e1567cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1567cd8",
  null
  
)

export default component.exports